module.exports = __webpack_public_path__ + "media/images/game/pages/goal-game-441f87fd95d2c38f636744bacc58ba36.png";